import { render, staticRenderFns } from "./FitsWithDrawer.vue?vue&type=template&id=916a17f6&"
import script from "./FitsWithDrawer.vue?vue&type=script&lang=ts&"
export * from "./FitsWithDrawer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports